import React from 'react';
import cl from './MarkdownView.module.css'

const MarkdownView = ({mdData}) => {

    return (
        <div className={cl.container}>
            <div className={cl.column}>
                <div className={cl.title__container}><b className={cl.title}>SOURCE</b></div>
                {mdData?.source && <div>{mdData.source}</div>}
            </div>
            <div className={cl.column}>
                <div className={cl.title__container}><b className={cl.title}>TARGET</b></div>
                {mdData?.target && <div>{mdData.target}</div>}
            </div>
        </div>
    );
};

export default MarkdownView;